// extracted by mini-css-extract-plugin
export default {"content":"_0780a8568c18303a","table":"_055eb20e49b96159","wrapper":"_5edb4869a2f06557"};